import { useEffect, useState } from "react";

const useScript = (url: string, resolve?: () => void) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const script = document.createElement("script");

    script.src = url;
    script.async = true;

    script.addEventListener("load", () => {
      setLoading(false);
      if (resolve) {
        resolve();
      }
    });

    script.addEventListener("error", () => {
      setLoading(false);
      setError(true);
    });

    document.body.appendChild(script);

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, [url, resolve]);

  return { loading, error };
};

export default useScript;
